export * from './GetFeaturedApps';

import getCustomProfileHeader from './GetCustomProfileHeader';
import getFavorites from './GetFavorites';
import getFeaturedApps from './GetFeaturedApps';
import getUserProfile from './GetUserProfile';

export default {
  getCustomProfileHeader,
  getFavorites,
  getFeaturedApps,
  getUserProfile,
};
